// AnalyticsPage.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Content.css";
import { Link, NavLink } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./AnalyticsPage.css";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Box,
  Button,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import TablePagination from "@mui/material/TablePagination";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { baseURL } from "../Constant";
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels
);
// const baseURL =
//   "https://atci.entrylevellearning.accenture.com/techexpress-apis";

const AnalyticsVideo = () => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [monthView, setMonthView] = useState([]);
  const [open, setOpen] = useState(null);
  const [selectedBarData, setSelectedBarData] = useState(null);
  const [analyticsError, setAnalyticsError] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalRows, setTotalRows] = useState(0); // Total number of rows
  const [monthdata, setmonthdata] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(1);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    getYearAnalytics();
  }, [selectedYear]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    getDetailPerMonth(selectedMonth);
  }, [page, rowsPerPage, selectedYear, selectedMonth]);
  const getDetailPerMonth = async (month) => {
    try {
      const response = await axios.post(
        `${baseURL}/fetchDetailsPerMonthvideo`,
        {
          month: month,
          year: selectedYear,
          page: page,
          rowsPerPage: rowsPerPage,
        },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      setmonthdata(response.data[0].Data);
      setAnalyticsError(false);
      setTotalRows(response.data[0].totalRows);
    } catch (error) {
      setAnalyticsError(true);
    }
  };
  const getYearAnalytics = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/yearanalyticsvideo`,
        { year: selectedYear },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      setMonthView(response.data);
      setAnalyticsError(false);
    } catch (error) {
      console.error("Error fetching year analytics:", error);
      setAnalyticsError(true);
    }
  };

  const downloadFile = async () => {
    setIsDownloading(true);
    try {
      const response = await axios.get(
        `${baseURL}/downloadAnalyticsvideo/${selectedYear}`,
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `VideoAnalyticsData_${selectedYear}.xlsx`);
      document.body.appendChild(link);
      link.click();
      setIsDownloading(false);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const fillMissingMonths = () => {
    const filled = [];
    for (let i = 1; i <= 12; i++) {
      const monthData = monthView
        .map((entry) => entry.Data.filter((item) => item.month === i))
        .flat();
      const totalViews = monthData.reduce(
        (acc, cur) => acc + cur.total_views,
        0
      );
      const uniqueViews = monthData.map((user) => user.unique_views);
      filled.push({
        month: i,
        total_views: totalViews,
        unique_views: uniqueViews.length > 0 ? uniqueViews[0] : 0,
      });
    }
    return filled;
  };

  const handleBarClick = (event) => {
    const activeElement = event.chart.getElementsAtEventForMode(
      event,
      "nearest",
      { intersect: true },
      true
    )[0];
    if (activeElement) {
      const { index } = activeElement;
      //  console.log("fill", fillMissingMonths()[index]);
      //  getDetailPerMonth(index + 1);
      setSelectedMonth(index + 1);
      setSelectedBarData(fillMissingMonths()[index]);
      setOpen(index);
    }
  };
  const options = {
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,

        title: {
          display: true,
          text: "Views",
          color: "grey",
          font: {
            weight: "bold",
          },
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Video Unique and Total Views",
        padding: 20,
        color: "#6e0089a6",
        font: {
          size: 20,
        },
      },
      datalabels: {
        color: "#6e0089",
        anchor: "end",
        align: "top",
        offset: 0,
        font: {
          weight: "bolder",
        },
      },
    },
    responsive: true,
    onClick: handleBarClick,
  };
  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const chartData = {
    labels,
    datasets: [
      {
        label: "Unique Views",

        data: fillMissingMonths().map((item) => item.unique_views),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Total Views",
        data: fillMissingMonths().map((item) => item.total_views),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  const handleCloseModal = () => {
    setOpen(null);
  };

  return (
    <>
      <div>
        <div>
          <Modal
            open={open !== null}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="custom-modal"
          >
            <Box className="tableWrapper">
              <TableContainer component={Paper} className="tableContainer">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="tableHeaderCell">
                        Enterprise ID
                      </TableCell>
                      <TableCell className="tableHeaderCell">
                        Total Views
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {monthdata &&
                      monthdata.map((item, index) => (
                        <TableRow
                          className="tableRow"
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                          }}
                        >
                          <TableCell className="tableCell">
                            {item.enterprise_id}
                          </TableCell>
                          <TableCell className="tableCell">
                            {item.total_count}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                sx={{
                  "& .MuiTablePagination-input": {
                    marginTop: "-10px", // Apply margin-top
                  },
                }}
                rowsPerPageOptions={[5, 10]}
                component="div"
                count={totalRows}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Box>
          </Modal>
        </div>
      </div>
      <div id="date-picker-container">
        <Button
          onClick={downloadFile}
          style={{ height: "30px" }}
          size="small"
          variant="outlined"
          disabled={isDownloading ? true : false}
        >
          {isDownloading ? "Loading..." : "Download"}
        </Button>
        <DatePicker
          selected={new Date(selectedYear, 0, 1)}
          onChange={(date) => setSelectedYear(date.getFullYear())}
          dateFormat="yyyy"
          showYearPicker
          className="yearPicker"
        />
      </div>
      {analyticsError && (
        <Alert severity="error">
          Failed to load data. Please refresh or contact the LIS team.
        </Alert>
      )}
      <div className="bar-container">
        <Bar plugins={[ChartDataLabels]} data={chartData} options={options} />
      </div>
    </>
  );
};

export default AnalyticsVideo;
